module.exports = __webpack_public_path__ + "static/media/contact.7ac4baf4.jpg";